import { FILE_TYPE, SOURCE_FILE_TYPES, PLAYBACK_STATE } from 'enums'
import * as API from '~/ServerAPI'
import { createMediaFile } from './sourceFiles'
import * as Selectors from '~/selectors'
import { openFolderById } from './folders'
import { setPlaybackClip } from './playback'
import { BehaviourSettings } from '~/config/constants/editorSettings'
import { selectBehaviourSettings } from '~/selectors/mainView'
import { setPendingSelectedAssetId } from './mainView'


export const importMediafileFromUrl = url => async (dispatch, getState) => {
  let response = null
  const folder = Selectors.selectImportFolderId(getState(), SOURCE_FILE_TYPES.MEDIA)
  await dispatch(openFolderById(SOURCE_FILE_TYPES.MEDIA, folder))
  try {
    response = await API.importFromUrl({ url, folder })
  } catch (err) {
    response = err.response
  }
  if (response?.data.id !== undefined) {
    const { id } = response.data
    await dispatch(createMediaFile(id, FILE_TYPE.URL))
    const state = getState()
    const sourceFile = Selectors.getSourceFileById(state, id)
    const behaviourSettings = selectBehaviourSettings(state)
    const playbackState = behaviourSettings?.[BehaviourSettings.autoPlaySelectedMedia]
      ? PLAYBACK_STATE.PLAY : PLAYBACK_STATE.PAUSE
    await dispatch(setPlaybackClip(sourceFile, playbackState))
    await dispatch(setPendingSelectedAssetId(id))
  }
}
